// extracted by mini-css-extract-plugin
module.exports = {"loadingLayer":"Chart_loadingLayer__2Luld","spinner":"Chart_spinner__1qyk-"};